module.exports = __webpack_public_path__ + "static/media/RMS_korisnicko_uputstvo.36c9e551.pdf";